import React from 'react';

const LoginVerify = React.lazy(() => import('./login-verify.page'));

export default LoginVerify;
